import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import Home from "./Home";
import TechStack from "./TechStack";
import TechStackSubPage from "./TechStackSubPage";
import ProjectsPage from "./ProjectsPage";
import ExperiencePage from "./ExperiencePage";
import PortfolioPage from "./PortfolioPage";
import { HomePageWrapper, PageWrapper } from "./PageWrapper";
import Menu from "./Menu";
import { ThemeProvider } from "styled-components";
import {
  certificationsData,
  experienceData,
  educationData,
  projectsData,
} from "./data/content";
import { RadarContextProvider } from "./RadarContextProvider";
import {
  techStackMainTheme,
  experience,
  education,
  intro,
  techStackSubPageTheme,
} from "./Themes";

// Layout for pages with Menu + PageWrapper + any theme
const LayoutWithMenu = ({ theme }: { theme: any }) => (
  <ThemeProvider theme={theme}>
    <PageWrapper>
      <Menu />
      <Outlet />
    </PageWrapper>
  </ThemeProvider>
);

// TechStack main page layout with main theme
const TechStackMainLayout = () => (
  <ThemeProvider theme={techStackMainTheme}>
    <PageWrapper>
      <Menu id={"main-menu"} />
      <Outlet /> {/* TechStack index page */}
    </PageWrapper>
  </ThemeProvider>
);

// Single wrapper for all TechStack subpages
const TechStackSubPageLayout = () => (
  <ThemeProvider theme={techStackSubPageTheme}>
    <PageWrapper>
      <Menu />
      <TechStackSubPage />
    </PageWrapper>
  </ThemeProvider>
);

const App = () => {
  return (
    <Router>
      <RadarContextProvider>
        <Routes>
          {/* Home */}
          <Route
            path="/"
            element={
              <ThemeProvider theme={intro}>
                <HomePageWrapper>
                  <Home />
                </HomePageWrapper>
              </ThemeProvider>
            }
          />

          {/* Portfolio / Experience / Certifications */}
          <Route element={<LayoutWithMenu theme={experience} />}>
            <Route path="portfolio" element={<PortfolioPage />} />
            <Route
              path="experience"
              element={
                <ExperiencePage title="Experience" jobs={experienceData} />
              }
            />
            <Route
              path="certifications"
              element={
                <ExperiencePage
                  title="Certifications"
                  jobs={certificationsData}
                />
              }
            />
            <Route
              path="projects"
              element={
                <ProjectsPage/>
              }
            />
          </Route>

          {/* Education */}
          <Route element={<LayoutWithMenu theme={education} />}>
            <Route
              path="education"
              element={
                <ExperiencePage title="Education" jobs={educationData} />
              }
            />
          </Route>

          {/* TechStack */}
          <Route path="techstack" element={<TechStackMainLayout />}>
            {/* Main TechStack page */}
            <Route index element={<TechStack />} />
          </Route>
          {/* TechStack */}
          <Route path="techstack">
            {/* Subpages */}
            <Route path=":categoryId" element={<TechStackSubPageLayout />} />
          </Route>
        </Routes>
      </RadarContextProvider>
    </Router>
  );
};

export default App;
